import { LOGIN_SUCCESS, LOGOUT } from '../actions/authActions';

const initialState = {
  token: localStorage.getItem('token') || null,
  isAuthenticated: !!localStorage.getItem('token'),
  isVerified: !!localStorage.getItem('isVerified'),
  userType: localStorage.getItem('userType'),
  tncDate: localStorage.getItem('tncDate'),
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return { ...state, token: action.payload.token, isAuthenticated: true, userType: action.payload.userType, tncDate: action.payload.tncDate };
    case LOGOUT:
      return { ...state, token: null, isAuthenticated: false, isVerified: false, userType: '' };
    default:
      return state;
  }
};


export default authReducer;
